const prefix = 'PROJECTS_SETTINGS';

export const GET_QUOTE_TEMPLATES = `${prefix}/GET_QUOTE_TEMPLATES`;
export const ADD_QUOTE_TEMPLATES = `${prefix}/ADD_QUOTE_TEMPLATES`;
